var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 131c-3,2 -6,4 -9,6 -4,1 -7,2 -11,2l-40 0c-4,0 -8,-1 -11,-2 -4,-2 -7,-4 -10,-6 -2,-3 -4,-6 -6,-10 -1,-3 -2,-7 -2,-11l0 -2c0,-7 0,-13 0,-18 0,-5 1,-10 2,-15 2,-5 4,-10 6,-14 3,-5 7,-10 12,-15 8,-7 17,-14 27,-20 11,-5 22,-10 34,-14 13,-4 25,-6 39,-8 13,-2 27,-3 41,-3 13,0 27,1 40,3 14,2 27,5 39,9 12,3 23,8 33,14 11,5 19,12 27,19 5,5 9,10 12,15 2,4 4,9 6,14 1,4 2,9 2,15 0,5 0,11 0,17l0 3c0,4 -1,8 -2,11 -2,4 -4,7 -6,10 -3,2 -6,4 -10,6 -3,1 -7,2 -11,2l-40 0c-4,0 -7,-1 -11,-2 -3,-2 -6,-4 -9,-6 -3,-3 -5,-6 -6,-9 -1,-3 -2,-6 -2,-9 -1,-3 -1,-6 -1,-9 1,-3 1,-6 1,-9 0,-3 0,-5 -1,-7 0,-3 -1,-5 -3,-6 -2,-2 -5,-4 -8,-4l-102 0c-3,0 -6,2 -8,4 -2,1 -3,3 -3,6 -1,2 -1,4 -1,7 0,3 0,6 1,9 0,3 0,6 -1,9 0,3 -1,6 -2,9 -1,3 -3,6 -6,9zm-57 -73c-4,4 -8,9 -10,12 -2,4 -4,8 -4,12 -1,4 -2,8 -1,13 0,4 0,10 0,15 0,4 1,7 3,9 1,1 3,2 5,2 3,1 5,2 8,2 4,0 7,0 10,0 4,0 7,0 10,0 4,0 7,0 9,0 3,-1 5,-1 7,-1 3,0 6,-1 8,-3 2,-2 3,-4 3,-6 1,-2 1,-5 1,-7 0,-3 0,-6 0,-9 0,-3 0,-6 0,-9 0,-3 1,-6 2,-9 2,-3 4,-6 6,-9 3,-3 6,-5 10,-6 3,-2 7,-2 10,-2l102 0c3,0 7,0 10,2 4,1 7,3 10,6 2,3 4,6 6,9 1,3 2,6 2,9 0,3 0,6 0,9 0,3 0,6 0,9 0,2 0,5 1,7 0,2 1,4 3,6 2,2 5,3 8,3 2,0 4,0 7,1 2,0 5,0 9,0 3,0 6,0 10,0 3,0 6,0 10,0 3,0 5,-1 8,-2 2,0 4,-1 5,-2 2,-2 3,-5 3,-9 0,-5 0,-11 0,-15 0,-5 0,-9 -1,-13 0,-4 -2,-8 -4,-12 -2,-4 -5,-8 -10,-12 -7,-7 -15,-13 -24,-18 -10,-5 -20,-9 -31,-12 -12,-4 -23,-6 -36,-8 -12,-2 -25,-2 -38,-2 -12,0 -25,1 -37,2 -13,2 -24,5 -35,8 -12,3 -22,8 -31,13 -9,5 -17,10 -24,17z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 165,
    width: 29.9983,
    height: 29.9983
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 165,
    width: 29.9983,
    height: 29.9983
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 165,
    width: 29.9983,
    height: 29.9983
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 215,
    width: 29.9983,
    height: 29.9983
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 215,
    width: 29.9983,
    height: 29.9983
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 215,
    width: 29.9983,
    height: 29.9983
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 265,
    width: 29.9983,
    height: 29.9983
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 265,
    width: 29.9983,
    height: 29.9983
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 265,
    width: 29.9983,
    height: 29.9983
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDial);
export default __webpack_public_path__ + "static/media/dial.022dc16b.svg";
export { ForwardRef as ReactComponent };